import { Text } from '@myinterview/component-library';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ALL_JOB_QUESTIONS_TYPE } from '../interfaces/jobInterface';
import { MODAL_ERROR_KEY } from '../interfaces/widgetInterface';
import { IDeviceSelectorList } from './DeviceSelectorList';
import { Errors } from './Errors';
import { Question } from './Question';

interface IProps extends IDeviceSelectorList {
  errorType: MODAL_ERROR_KEY | null;
  onDisplayPermissionSteps: () => void;
  onReInitRecorder: () => void;
  onRecorderRetry: () => void;
  currentQuestionObj: ALL_JOB_QUESTIONS_TYPE | undefined;
  isRecording: boolean;
}

export const RecorderModal:React.FC<IProps> = ({
  errorType, onDisplayPermissionSteps, currentQuestionObj,
  deviceList, selectedDevice, onDeviceSelected, isRecording, onReInitRecorder, onRecorderRetry,
}) => {
  const { t } = useTranslation();
  return (
    <div className="myinterview-widget-recorder-modal">
      <div className="myinterview-widget-recorder-modal__content-wrapper">
        {!isRecording && currentQuestionObj && !errorType ? (
          <div className="myinterview-widget-recorder-modal__question">
            <Question questionObj={currentQuestionObj} isInner />
          </div>
        ) : errorType ? (
          <Errors
            errorType={errorType}
            onDisplayPermissionSteps={onDisplayPermissionSteps}
            onReInitRecorder={onReInitRecorder}
            onRecorderRetry={onRecorderRetry}
            deviceList={deviceList}
            selectedDevice={selectedDevice}
            onDeviceSelected={onDeviceSelected}
            deviceType="audio"
          />
        ) : (
          <div className="myinterview-widget-recorder-modal__waiting">
            <Text>{t('recorder.permissions.permission')}</Text>
          </div>
        )}
      </div>
    </div>
  );
};
